import {Paper} from '@mui/material';
import React, {useCallback} from 'react';
import Controls from '../../components/Slider/Controls';
import Header from '../../components/Slider/Header';
import Table from '../Contacts/Table';
import ContactLocations from './ContactLocations';
import NewContact from './NewContact';
import NewOrExistingContact from './NewOrExistingContact';
import Who from './Who';

const SelectContact = ({session, onBack, onNext}) => {

  const handleBack = useCallback(() => {
    onBack(
      session.selectedCompany ? {type: NewOrExistingContact.type, id: NewOrExistingContact.type} : {
        type: Who.type,
        id: Who.type
      }
    )
  }, [onBack, session]);

  return (
    <>
      <Header>Select an Existing Contact</Header>
      <Paper>
        <Table
          title=""
          company={session?.selectedCompany}
          endUsers={session?.selectedCompany ? false : undefined}
          onSelect={({id, first_name, last_name}) => onNext(
            {type: ContactLocations.type, id: ContactLocations.type},
            {selectedContact: {id, first_name, last_name}}
          )}
          canCreate={false}
        />
      </Paper>
      <Controls
        onBack={handleBack}
        onNext={() => onNext({type: NewContact.type, id: NewContact.type})}
        nextLabel="Create a New Contact"
      />
    </>
  );
};

SelectContact.type = 'SELECT_CONTACT';

export default SelectContact;
